import { ConfirmDialog } from '@gogame/components';
import { useScreenModalV2 } from '@gogame/screens';

import { startJob as startJobSource } from 'scenes/TapjoyBidUpdate/sources/tapjoy-bid-update';
import { messagesTapjoyBidUpdate } from '../messages';
import { useQueryClient, useMutation } from '@gogame/query';
import {
  errorDetails,
  status as statusKey,
  startJob as startJobKey,
} from '../queryKeyFactory';

export const useStartJob = () => {
  const uploadMessage = messagesTapjoyBidUpdate.upload();
  const queryClient = useQueryClient();

  const mutation = useMutation(startJobKey(), startJobSource, {
    successMessage: () => uploadMessage.completed(),
    refresh: false,
  });

  const showModal = useScreenModalV2(ConfirmDialog);

  return [
    async (params) => {
      await showModal({
        title: `Confirm`,
        confirmActionLabel: 'Upload',
        bodyText: `Are you sure you want to upload ${params.file.name}?`,
      });

      const result = await mutation.mutateAsync(params);

      await queryClient.invalidateQueries(statusKey);
      await queryClient.invalidateQueries(errorDetails);

      return result;
    },
    mutation,
  ];
};
